import './index.css';
import { useEffect } from 'react';
import { useLink } from 'react-router-stack';
import { Header, ScreenBackground, RouteWrapper, Text, View } from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import useTheme from '../../../utilities/hooks/theme';

const PaytmCallback = () => {
  const navigate = useLink();
  const { AccountTheme: theme } = useTheme();

  useEffect(() => {}, []);

  const onPressBack = () => {
    EventEmitter.emit('BalanceUpdate');
    navigate.go(-2);
  };

  const infoColor = {
    color: theme.link
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onPressBack} />
        <View className="payment-callback-container">
          <View onPress={onPressBack} className={'payment-callback-info'}>
            <Text style={infoColor} className="payment-callback-info-title">
              {'Click here, when complete transaction.'}
            </Text>
          </View>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};

export default PaytmCallback;
